import styled from 'styled-components';
import { colorTheme } from '../../../core/configs';

export const StyledImg = styled.img`
  width: 100%;
  height: 180px;
  min-width: 287px;
`;

export const StyledDesc = styled.div`
  font-size: 0.8rem;
  line-height: 1.2rem;
  -webkit-letter-spacing: 0rem;
  -moz-letter-spacing: 0rem;
  -ms-letter-spacing: 0rem;
  letter-spacing: 0rem;
  font-weight: 400;
  text-align: center;
  color: ${colorTheme.darkFaded};

  a {
    font-size: 0.8rem;
    line-height: 1.2rem;
    -webkit-letter-spacing: 0rem;
    -moz-letter-spacing: 0rem;
    -ms-letter-spacing: 0rem;
    letter-spacing: 0rem;
    font-weight: 400;
    text-align: left;
    color: ${colorTheme.primary};
  }
`;
